import { Component } from 'react';
import PropTypes from 'prop-types';

export default class Favicon extends Component {
  componentDidMount() {
    this.updateFavicon(this.props.icon);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.icon !== nextProps.icon) {
      this.updateFavicon(nextProps.icon);
    }
  }

  updateFavicon(icon) {
    // TODO: Temp path for testing
    document.querySelector("link[rel*='icon']").href =
      process.env.PUBLIC_URL + '/' + icon;
  }

  render() {
    return null;
  }
}

Favicon.propTypes = {
  icon: PropTypes.string.isRequired,
};
